import { ManageCutOffViewModel } from "./ManageCutOffViewModel";

export const mapChanges = (
  data: ManageCutOffViewModel[],
  inputValues: ManageCutOffViewModel
): ManageCutOffViewModel[] => {
  return data.map((item) => {
    return {
      ...item,
      CutOffTime: inputValues.CutOffTime || item.CutOffTime,
      ReturnCutOffTime: inputValues.ReturnCutOffTime || item.ReturnCutOffTime,
      TransitTime: inputValues.TransitTime || item.TransitTime,
      ReturnTransitTime:
        inputValues.ReturnTransitTime || item.ReturnTransitTime,
      // -1 is unchanged BranchID
      BranchID:
        inputValues.BranchID === -1 ? item.BranchID : inputValues.BranchID,
    };
  });
};
